import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { LanguageService } from "@carnegie-learning/data-access-angular-passport";
import * as languagesActions from "../actions/languages.action";

@Injectable()
export class LanguagesEffects {
    constructor(
        private actions$: Actions,
        private languageService: LanguageService
    ) {}

    loadLanguages$ = createEffect(() =>
        this.actions$.pipe(ofType(languagesActions.loadLanguages)).pipe(
            switchMap(latestPayload => {
                return this.languageService.getActiveLanguages().pipe(
                    map(activeLanguages =>
                        languagesActions.loadLanguagesSuccess({
                            payload: activeLanguages
                        })
                    ),
                    catchError(error =>
                        of(languagesActions.loadLanguagesFail({ payload: error }))
                    )
                );
            })
        )
    );
}
